import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import LearningMapBrowser from './learning-map-browser/learning-map-browser';
import LearningMapTable from './learning-map-table/learning-map-table';
import { CONTENT_TYPES_LIST } from '@/utils/constants';
import { searchAPI } from '@/providers/apis/search/search';
import LearningMapPullout from './learning-map-pullout/learning-map-pullout';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';

@Component({
    name: 'learning-map',
    components: {
        'material-icon': GoogleMaterialIcon,
        'learning-map-browser': LearningMapBrowser,
        'learner-table': LearningMapTable,
        'learner-pullout': LearningMapPullout,
        'scale-loader': ScaleLoader,
    },
})

export default class LearningMap extends Vue {



    /**
     * @property {JSON}
     * Property to store default content types
     */
    public contentTypes = CONTENT_TYPES_LIST;

    // -----------------------------------------------------------------------
    // Properties
    private tableData: any = {};

    private isShowTable: boolean = false;

    private isScroll: boolean = false;

    private pullOutContents: any = {};

    private pullOutInfo: any = {};

    private showPullout: boolean = false;

    private popContents: any = {};

    private isLoading: boolean = false;
    // ----------------------------------------------------------------------
    // Actions

    private onGenarate(tableData: any) {
        this.isShowTable = true;
        this.isScroll = true;
        this.tableData = tableData;
    }

    private onScroll() {
        this.isScroll = false;
        document.body.scrollIntoView({behavior: 'smooth'});
    }

    private onSelectContentType(content: any) {
      this.isLoading = true;
      this.getLearningMapCompetencyData(content);
    }
    // ---------------------------------------------------------------
    // Hooks

    // ------------------------------------------------------------------------
    // Methods
   /**
    * @function getLearningMapCompetencyData
    * Method to request and process competency data
    */
    private getLearningMapCompetencyData(content: any) {
     const controller = this;
     const competencyId = content.contentId;
     const contentType = content.contentType;
     controller
       .fetchCompetencyContentById(competencyId)
       .then((learningMapData: any) => {
         const fetchedPullOutData: any = controller.getLearningMapDataByContentType(
           learningMapData,
           contentType,
         );
         this.pullOutContents = {};
         this.pullOutContents[contentType] = fetchedPullOutData.contents;
         this.pullOutInfo = fetchedPullOutData;
         this.popContents = {
          pullOutContents: this.pullOutContents,
          pullOutInfo: this.pullOutInfo,
          showPullout: this.showPullout,
         };
         this.showPullout = true;
         this.isLoading = false;
       });
   }


  /**
   * @function fetchLearningMapContent
   * Function to fetch a competency content
   */
  private fetchCompetencyContentById(competencyId: string) {
    const controller = this;
    const length = 0;
    const start = 9;
    const filters = {
      id: competencyId,
    };
    return searchAPI.learningMapsCompetencyContent(filters, length, start)
    .then((competencyInfo) => {
      return competencyInfo;
    });
  }
  /**
   * @function getLearningMapDataByContentType
   * Method to fetch user selected content type info
   */
  private getLearningMapDataByContentType(learningMapData: any, contentType: any) {
    const controller = this;
    const contentTypes = this.contentTypes;
    let selectedLearningMapData = {
      id: learningMapData.gutCode,
      displayCode: learningMapData.code,
      title: learningMapData.title,
      type: contentType,
      subject: learningMapData.subject,
      course: learningMapData.course,
      domain: learningMapData.domain,
    };
    let contentData: any = [];
    if (contentTypes[`${contentType.toUpperCase()}`]) {
      const contentInfo = learningMapData.contents[`${contentType}`];
      contentData = {
        contents: learningMapData.learningMapsContent[`${contentType}`],
        totalHitCount: contentInfo.totalHitCount,
      };
    } else {
      if (contentType === 'signatureCollection') {
        contentData = {
          contents: learningMapData.signatureContents.collections,
          totalHitCount: learningMapData.signatureContents.collections.length,
        };
      } else if (contentType === 'signatureAssessment') {
        contentData = {
          contents: learningMapData.signatureContents.assessments,
          totalHitCount: learningMapData.signatureContents.assessments.length,
        };
      }
    }
    selectedLearningMapData = Object.assign(
      selectedLearningMapData,
      contentData,
    );
    return selectedLearningMapData;
  }
}
